// extracted by mini-css-extract-plugin
export var label = "TrendingNow-module--label--c82f2";
export var link = "TrendingNow-module--link--766e9";
export var title = "TrendingNow-module--title--e6305";
export var trending = "TrendingNow-module--trending--b066e";